import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SolidChevron from "../../Icons/SolidChevron";
import InputFormBorder from "../../Common/InputFormBorder/InputFormBorder";
import styles from "./reservationCheckCustomerInfo.module.css";
import InputPhone from "@/components/InputPhone/InputPhone";

const ReservationCheckCustomerInfo = ({
  handleChange,
  values,
  errors,
  countryCode,
}) => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.app.language);

  const change = (e) => {
    handleChange({ target: { name: "phone", value: e }, persist: () => {} });
    setPhoneError("");
  };

  const handleCountryChange = (country) => {
    handleChange({
      target: { name: "countryCode", value: country },
      persist: () => {},
    });
  };

  const onHandleChangePhone = (e) => {
    handleChange({ target: { name: "phone", value: e }, persist: () => {} });
  };

  return (
    <div>
      <div className="position-relative d-flex">
        <div style={{ flex: "1", marginRight: "10px" }}>
          <InputFormBorder
            color="#757575"
            name="customerName"
            type="text"
            onChange={handleChange}
            value={values.customerName}
            error={errors.customerName}
            placeholder={t("firstName")}
            customClass="border-none p-0"
          />
        </div>

        <div style={{ flex: 1 }}>
          <InputFormBorder
            color="#757575"
            name="customerLastName"
            type="text"
            onChange={handleChange}
            value={values.customerLastName}
            error={errors.customerLastName}
            placeholder={t("lastName")}
            customClass="border-none p-0"
          />
        </div>
      </div>

      <InputPhone
        placeholder={t("mobile")}
        onHandleChange={onHandleChangePhone}
        error={errors.phone}
        t={t}
        countryCode={countryCode}
      />

      <InputFormBorder
        color="#757575"
        name="email"
        type="email"
        icon={"mail"}
        onChange={handleChange}
        value={values.email}
        error={errors.email}
        placeholder={"E-mail"}
        label={t("reservationEmail")}
        forceLowecase={true}
        border={"none"}
      />
    </div>
  );
};

export default ReservationCheckCustomerInfo;
